// extracted by mini-css-extract-plugin
export default {"cta":"I5","grey":"J5","dark":"K5","chip":"L5","card":"M5","nonclickable":"N5","top":"O5","left":"P5","span":"Q5","name":"R5"};
    if(module.hot) {
      // 1714422958136
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  